<template>
  <div>
    <div class="Fuell-Toolbar">
      <h3
        class="Fuell-Toolbar--subtitle"
        v-t="{ path: 'cards_physical_cards_explanation'}"
      ></h3>
    </div>

    <cards-container @showDownloadModal="showDownloadModal"></cards-container>
    <transactions-export-modal
      v-if="showTransactionDownloadModalFlag"
      :open.sync="showTransactionDownloadModalFlag"
      :extraFilters="downloadDataFilters"
      overlay
      @closeModal="removeHash"
    ></transactions-export-modal>
  </div>

</template>

<script>
import CardsContainer from '../_components/_shared/CardsContainer'
const TransactionsExportModal = () => import('../../transactions/_components/_shared/TransactionsExportModal.vue')

export default {
  name: 'PhysicalCardsIndex',
  components: {
    CardsContainer,
    TransactionsExportModal
  },
  data () {
    return {
      downloadDataFilters: {},
      showTransactionDownloadModalFlag: false
    }
  },
  computed: {
    isUser () {
      return this.$store.getters['LoginStore/isUser']
    }
  },
  methods: {
    removeHash () {
      if (window.location.hash === '#exportHistory') {
        window.location.hash = ''
      }
    },
    showDownloadModal (filters) {
      this.downloadDataFilters = filters
      this.showTransactionDownloadModalFlag = true
    },
    async fetchCards () {
      let filters = {
        'type.code': 'MEMBER_PHYSICAL',
        'own': true
      }

      await this.$store.dispatch('CardsStore/setCardsFilters', filters)
    }
  },
  async created () {
    this.$store.dispatch('CardsStore/clearStore')
    await this.fetchCards()
  }

}
</script>
